import React, { useState, useEffect } from "react";
import styles from "./plpBottomDrawer.scss";
import BottomDrawer from "@tw/shared-ui-components/lib/components/bottomDrawer/bottomDrawer";
import { toastMsg } from "@tw/shared-ui-components/lib/components/toastMessage/toastMessage";
import NewSpinner from "@tw/shared-ui-components/lib/components/newSpinner/newSpinner";
import FullPageLoader from "@tw/shared-ui-components/lib/components/fullPageLoader/fullPageLoader";
import { getPdmApiUrl } from "../../utils/helper";
import axios from '@tw/shared-ui-components/lib/utils/axios_interceptor';
import find from "lodash/find";
import DialogModal from "../DialogModal/DialogModal";
function PlpBottomDrawer({
  submitButtonWidth,
  setOpen,
  open,
  productCode,
  selectedProductIds,
  toggle,
  setToggle,
  setdisplaySelectOption,
  setSelectedProductIds,
  setDisableAddToCart,
  // setInput,
  // isInput,
}) {
  const [isInput, setInput] = useState(false);
  const [items, setItem] = useState(false);
  const [listTitle, setListTitle] = useState("");
  const [shareList, setShareList] = useState([]);
  const [selectedShareId, setSelectedShareId] = useState("");
  const [isContinueVisible, setIsContinueVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  // const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [listAction, setListAction] = useState("");
  // const [isError, setIsError] = useState(false);
  const [isDialogLoading, setIsDialogLoading] = useState(false);

  const openModal = () => {
    setShowModal((prev) => !prev);
  };

  const onExceedingListNameLimit = () => {
    setOpen(false);
    toastMsg("上限為 20 字", null, "default_error_one_line");
    setListTitle("");
  };

  useEffect(() => {
    if (!open) {
      setIsContinueVisible(false);
      setInput(false);
      setItem(false);
      setSelectedShareId("");
    }
  }, [open]);
  const selectedProducts = productCode
    ? [...selectedProductIds, productCode]
    : selectedProductIds;

  const addToList = async (action) => {
    let title;
    if (action === "createList")
      title = listTitle.length < 21 ? listTitle : onExceedingListNameLimit();
    else title = find(shareList, { shareId: selectedShareId })?.title;

    const defaultDescription = "專屬推薦給您的安麗好物!";
    const description = find(shareList, {
      shareId: selectedShareId,
    })?.description;

    if (!title) return;
    setInput(false);
    setOpen(false);

    const ListproductCount =
      action === "updateList"
        ? (find(shareList, { shareId: selectedShareId })?.productList).length
        : null;

    action === "createList"
      ? setListAction("createList")
      : setListAction("updateList");

    if (
      action === "createList" ||
      (action === "updateList" &&
        ListproductCount + selectedProducts.length <= 10)
    ) {
      const payload = {
        skuCodes: selectedProducts,
        title: title,
        description: description || defaultDescription,
        shareId: action === "createList" ? "" : selectedShareId,
      };
      setIsDialogLoading(true);
      const apiUrl = getPdmApiUrl();
      axios
        .post(`/plp/share-list`, payload, {
          baseURL: apiUrl,
        })
        .then(() => {
          setSelectedProductIds && setSelectedProductIds([]);
          setInput(false);
          setOpen(false);
          setListTitle("");
          setdisplaySelectOption && setdisplaySelectOption(false);
          setToggle && setToggle(!toggle);
          setDisableAddToCart && setDisableAddToCart(false);
          openModal();
          setIsDialogLoading(false);
        })
        .catch((err) => {
          setIsDialogLoading(false);
          setdisplaySelectOption && setdisplaySelectOption(false);
          setSelectedProductIds && setSelectedProductIds([]);
          setToggle && setToggle(!toggle);
          if (action === "createList") {
            toastMsg("新增清單操作失敗");
          } else toastMsg("更新清單操作失敗");
          console.log(err);
        });
    } else {
      // setIsError(true);
      // setShowErrorDialog(true);
      toastMsg("打包清單最多添加10個商品", null, "default_error_one_line");
      setInput(false);
      setListTitle("");
      // setToggle && setToggle(!toggle);
      setDisableAddToCart && setDisableAddToCart(false);
    }
  };

  const handleTitleChange = (e) => {
    setListTitle(e.target.value);
  };

  const continueHandleClick = () => {
    addToList("updateList");
    setOpen(false);
    // setdisplaySelectOption && setdisplaySelectOption(false);
    // setSelectedProductIds && setSelectedProductIds([]);
    setItem(false);
  };

  const onClickHandler = () => {
    setInput(false);
    setItem(true);

    setIsLoading(true);

    const apiUrl = getPdmApiUrl();
    axios
      .post(
        `/plp/query-share-list-customer`,
        {},
        {
          baseURL: apiUrl,
        }
      )
      .then((res) => {
        setShareList(
          res?.data?.shareList?.filter(
            (shareListItem) => shareListItem.status == 1
          )
        );
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  const getShareList = () => {
    if (isLoading)
      return (
        <div className={styles["list_spinner"]}>
          <NewSpinner />
        </div>
      );

    return (
      <>
        {shareList?.length > 0 ? (
          shareList?.map((item, index) => (
            <div key={index} className={styles["item-val"]}>
              <div
                className={`${styles["select_radio"]} ${item?.shareId === selectedShareId ? styles["active"] : ""
                  }`}
              >
                <label className={styles["labl"]} htmlFor={`check-${index}`}>
                  <input
                    type="radio"
                    name="radio_btns"
                    id={`check-${index}`}
                    onChange={() => {
                      setSelectedShareId(item.shareId);
                      setIsContinueVisible(true);
                    }}
                  />
                  <span className={styles["radio"]}></span>
                  <span className={styles["text"]}>
                    {item.title + "  "} ({item.productList.length})
                  </span>
                </label>
              </div>
            </div>
          ))
        ) : (
          <span className={styles["not-sharelist"]}>未找到列表</span>
        )}
      </>
    );
  };

  return (
    <>
      <BottomDrawer
        onSubmit={continueHandleClick}
        submitButtonText={isContinueVisible && "下一步"}
        submitButtonWidth={submitButtonWidth}
        setOpen={setOpen}
        open={open}
      >
        {!isInput && (
          <>
            <div
              style={{
                height: "312px",
                fontFamily: "gt-walsheim",
                paddingLeft: "20px",
                paddingRight: "20px",
              }}
            >
              <div className={styles["list-heading"]}>選擇要加入的打包清單</div>
              <hr
                style={{ borderTop: "0.5px solid #E4E4E4", height: "0.5px" }}
              />
              <div className={styles["radio-select"]}>
                <div className={styles["radio_options"]}>
                  <div
                    className={`${styles["select_radio"]} ${isInput ? styles["active"] : ""
                      }`}
                  >
                    <label className={styles["labl"]}>
                      <input
                        type="radio"
                        name="radio_btns"
                        value="打包"
                        onClick={() => {
                          setItem(false);
                          setInput(true);
                          setIsContinueVisible(false);
                        }}
                      />
                      <span className={styles["radio"]}></span>
                      <span className={styles["text"]}>新增一份清單</span>
                    </label>
                  </div>
                </div>

                <div className={styles["addtolist"]}>
                  <div className={styles["radio_options"]}>
                    <div
                      className={`${styles["select_radio"]} ${items ? styles["active"] : ""
                        }`}
                    >
                      <label className={styles["labl"]}>
                        <input
                          type="radio"
                          name="radio_btns"
                          value="加入現有清單"
                          onClick={onClickHandler}
                        />
                        <span className={styles["radio"]}></span>
                        <span className={styles["text"]}>加入現有清單</span>
                      </label>
                    </div>
                  </div>

                  <div
                    className={
                      items === true
                        ? styles["visible-list"]
                        : styles["not-visible-list"]
                    }
                  >
                    <div className={styles["radio_options"]}>
                      {getShareList()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {isInput && (
          <>
            <div className={styles["existing-list"]}>
              <div className={styles["text"]}>輸入新建清單名字</div>
              <div className={styles["input_text"]}>
                <input
                  type="text"
                  id="inputtext"
                  value={listTitle}
                  onChange={handleTitleChange}
                />
                <button
                  className={`${styles["createList-btn"]} ${!listTitle.length ? styles["disabled"] : ""
                    }`}
                  onClick={() => {
                    if (!listTitle.length) return;
                    addToList("createList");
                  }}
                >
                  確認
                </button>
              </div>
            </div>
          </>
        )}
      </BottomDrawer>
      {isDialogLoading && <FullPageLoader />}
      <DialogModal
        showModal={showModal}
        setShowModal={setShowModal}
        setListAction={setListAction}
        listAction={listAction}
      />
      {/* <DialogModal */}
      {/* // showModal={showErrorDialog} */}
      {/* // setShowModal={setShowErrorDialog} */}
      {/* // isError={isError} */}
      {/* // errorMessage="商品總數超過上限" */}
      {/* // /> */}
    </>
  );
}
PlpBottomDrawer.defaultProps = {
  selectedProductIds: [],
};
export default PlpBottomDrawer;
